import React from "react";

export default () => {
  return (
    <footer className="bg-dark text-white mt-5 p-2 text-center">
      Copyright &copy; {new Date().getFullYear()}
    </footer>
  );
};
